/** Keyword positions and a PageSpeed reading for the demo site. */

import type { KeywordRanking, PageSpeedData } from '../../services/seoService';
import { DEMO_DOMAIN } from './site';
import { dayKey, hoursAgo } from './time';

function history(positions: number[]): Record<string, number> {
  const out: Record<string, number> = {};
  positions.forEach((position, index) => {
    out[dayKey(-(positions.length - 1 - index) * 7)] = position;
  });
  return out;
}

export const demoKeywords: KeywordRanking[] = [
  {
    id: 1,
    keyword: 'plumber madison wi',
    currentPosition: 6,
    previousPosition: 9,
    searchVolume: 1600,
    url: `https://${DEMO_DOMAIN}/`,
    device: 'mobile',
    country: 'US',
    history: history([14, 12, 11, 9, 9, 6]),
  },
  {
    id: 2,
    keyword: 'emergency plumber madison',
    currentPosition: 4,
    previousPosition: 5,
    searchVolume: 480,
    url: `https://${DEMO_DOMAIN}/emergency`,
    device: 'mobile',
    country: 'US',
    history: history([9, 8, 6, 5, 5, 4]),
  },
  {
    id: 3,
    keyword: 'water heater replacement madison',
    currentPosition: 8,
    previousPosition: 8,
    searchVolume: 320,
    url: `https://${DEMO_DOMAIN}/services/water-heaters`,
    device: 'desktop',
    country: 'US',
    history: history([12, 11, 10, 8, 8, 8]),
  },
  {
    id: 4,
    keyword: 'drain cleaning near me',
    currentPosition: 12,
    previousPosition: 10,
    searchVolume: 2400,
    url: `https://${DEMO_DOMAIN}/services/drain-cleaning`,
    device: 'mobile',
    country: 'US',
    history: history([15, 13, 11, 10, 10, 12]),
  },
  {
    id: 5,
    keyword: 'sump pump repair dane county',
    currentPosition: 3,
    previousPosition: 7,
    searchVolume: 170,
    url: `https://${DEMO_DOMAIN}/services/sump-pumps`,
    device: 'desktop',
    country: 'US',
    history: history([11, 10, 8, 7, 7, 3]),
  },
  {
    id: 6,
    keyword: 'plumber middleton wi',
    currentPosition: 9,
    previousPosition: 11,
    searchVolume: 210,
    url: `https://${DEMO_DOMAIN}/areas/middleton`,
    device: 'mobile',
    country: 'US',
    history: history([18, 16, 14, 11, 11, 9]),
  },
];

export const demoPageSpeed: PageSpeedData = {
  performance: 96,
  accessibility: 100,
  bestPractices: 96,
  seo: 100,
  fcp: 900,
  lcp: 1400,
  cls: 0.01,
  tbt: 40,
  speedIndex: 1600,
  fetchedAt: hoursAgo(9),
};
